"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfo = getInfo;
exports.calculateIEP = calculateIEP;
exports.calculateIEPChart = calculateIEPChart;
exports.getColorForIEP = getColorForIEP;
exports.calculateCharge = calculateCharge;
const aminoAcids_1 = require("./aminoAcids");
const IEP = __importStar(require("./isoElectricPoint"));
const splitPeptide_js_1 = require("./splitPeptide.js");
__exportStar(require("./allowNeutralLoss.js"), exports);
__exportStar(require("./chargePeptide.js"), exports);
__exportStar(require("./sequenceToMF.js"), exports);
__exportStar(require("./generatePeptideFragments.js"), exports);
__exportStar(require("./digestPeptide.js"), exports);
__exportStar(require("./splitPeptide.js"), exports);
function getInfo() {
    return aminoAcids_1.aminoAcids;
}
// sequence should be in the "right" format like HAlaGlyProOH
function calculateIEP(sequence) {
    let aas = (0, splitPeptide_js_1.splitPeptide)(sequence);
    let result = IEP.calculateIEP(aas);
    return result;
}
function calculateIEPChart(sequence) {
    let aas = (0, splitPeptide_js_1.splitPeptide)(sequence);
    let result = IEP.calculateChart(aas);
    return result;
}
function getColorForIEP(iep) {
    return IEP.getColor(iep);
}
function calculateCharge(sequence, ph) {
    let aas = (0, splitPeptide_js_1.splitPeptide)(sequence);
    return IEP.calculateCharge(aas, ph);
}
//# sourceMappingURL=index.js.map